import * as React from "react";
import { TextInput, ArrayInput, SimpleFormIterator, required, minLength, maxLength } from 'react-admin';
import { useTranslate } from 'ra-core';
import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
    arrayInput: {
        "& ul > p": {
            display: 'none',
        },
        "& > label": {
            fontSize: theme.typography.h5.fontSize,
            top: -20
        }
    }
}));

export const TagListInput = (props) =>  {
    const { source } = props;
    const translate = useTranslate();
    const classes = useStyles();
    return (
        <ArrayInput source={source} className={classes.arrayInput} validate={[required(translate(`cmss.resources.tag-group.validations.tags.required`))]} label={translate(`cmss.resources.tag-group.fields.tags`)} margin={'normal'} style={{marginTop: '24px'}}>
            <SimpleFormIterator getItemLabel={() => ''} disableReordering>
                <TextInput source="name" label={translate(`cmss.resources.tag-group.fields.tag-name`)} validate={[required(), minLength(3), maxLength(255)]} style={{marginBottom: '0px', marginTop: '20px'}} variant="outlined" size="small"/>
            </SimpleFormIterator>
        </ArrayInput>
    );
}
